import { type UseQueryResult, useQuery } from 'react-query';
import {
  CustomerSuccessService,
  type ParticipantSearchResultDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

const useSearchParticipants = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  companyId?: string,
  query?: string,
  enabled: boolean = true
): UseQueryResult<ParticipantSearchResultDto[] | undefined, unknown> => {
  return useQuery(
    ['searchParticipants', companyId, query],
    async () => {
      return await handleRequest(
        CustomerSuccessService.getApiCustomerCustomerSuccessParticipantsSearch(companyId, query)
      );
    },
    {
      enabled: enabled && (query === undefined || query.length >= 2),
      keepPreviousData: true,
    }
  );
};

export default useSearchParticipants;
